import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import BrandIcon from '../../components/BrandIcon';
import api from '../../services/api';
import toast from 'react-hot-toast';

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Erro ao ler arquivo'));
    reader.readAsDataURL(file);
  });
}

export default function DeliveryRegister() {
  const [brands, setBrands] = useState([]);
  const [form, setForm] = useState({
    name: '', email: '', phone: '', pixKeyCpf: '', cnhFrontImage: '', cnhBackImage: '',
    anpCode: '', vehiclePlate: '', vehicleModel: '', password: '', brands: [], acceptedTerms: true,
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const DEFAULT_BRANDS = [
    { id: 'liquigas', name: 'Liquigás', color: '#9CA3AF' },
    { id: 'ultragaz', name: 'Ultragaz', color: '#1E40AF' },
    { id: 'supergasbras', name: 'Supergasbras', color: '#D97706' },
    { id: 'nacional_gas', name: 'Nacional Gás', color: '#C0C0C0' },
    { id: 'consigaz', name: 'Consigaz', color: '#38BDF8' },
  ];

  useEffect(() => {
    api.get('/brands')
      .then(r => setBrands(r.data))
      .catch(() => setBrands(DEFAULT_BRANDS));
  }, []);

  const f = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const handleImageCapture = async (field, file) => {
    if (!file) return;
    try {
      const dataUrl = await readFileAsDataUrl(file);
      setForm(prev => ({ ...prev, [field]: dataUrl }));
      toast.success('Imagem anexada com sucesso');
    } catch {
      toast.error('Não foi possível anexar a imagem');
    }
  };

  const toggleBrand = (id) => {
    setForm(p => ({
      ...p,
      brands: p.brands.includes(id) ? p.brands.filter(b => b !== id) : [...p.brands, id],
    }));
  };

  const handle = async (e) => {
    e.preventDefault();
    if (form.brands.length === 0) { toast.error('Selecione ao menos uma marca'); return; }
    if (!form.password || form.password.length < 6) { toast.error('A senha deve ter pelo menos 6 caracteres'); return; }
    setLoading(true);
    try {
      const payload = { 
        name: form.name, 
        email: form.email, 
        phone: form.phone, 
        pixKeyCpf: form.pixKeyCpf, 
        cnhFrontImage: form.cnhFrontImage, 
        cnhBackImage: form.cnhBackImage,
        anpCode: form.anpCode, 
        vehiclePlate: form.vehiclePlate, 
        vehicleModel: form.vehicleModel, 
        password: form.password, 
        brands: form.brands, 
        acceptedTerms: form.acceptedTerms,
        role: 'delivery' 
      };
      console.log('Enviando cadastro:', payload);
      await api.post('/auth/register', payload);
      toast.success('Cadastro realizado com sucesso!');
      nav('/entregador/dashboard');
    } catch (err) {
      console.error('Erro cadastro:', err);
      const msg = err.response?.data?.error || err.message || 'Erro ao cadastrar';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen bg-white flex flex-col">
      <div className="bg-gradient-to-b from-[#0D1B2A] to-[#1B263B] px-6 pt-14 pb-10 text-white">
        <button onClick={() => nav('/entregador/login')} className="text-2xl mb-6 block">←</button>
        <div className="text-5xl mb-3">🛵</div>
        <h1 className="text-2xl font-black">Cadastro de Entregador</h1>
        <p className="text-gray-400 text-sm mt-1">Comece a ganhar hoje</p>
      </div>

      <form onSubmit={handle} className="flex-1 px-6 py-6 space-y-4 overflow-y-auto">
        {[
          { k: 'name', label: 'Nome completo', type: 'text', ph: 'João Silva' },
          { k: 'email', label: 'Email', type: 'email', ph: 'seu@email.com' },
          { k: 'phone', label: 'Celular c/ WhatsApp', type: 'tel', ph: '(11) 99999-9999' },
          { k: 'pixKeyCpf', label: 'Chave PIX (CPF)', type: 'text', ph: '000.000.000-00' },
          { k: 'anpCode', label: 'Código ANP do fornecedor do gás', type: 'text', ph: '000000' },
          { k: 'vehiclePlate', label: 'Placa do veículo', type: 'text', ph: 'ABC1D23' },
          { k: 'vehicleModel', label: 'Modelo do veículo', type: 'text', ph: 'Honda CG 160' },
          { k: 'password', label: 'Senha', type: 'password', ph: '••••••••' },
        ].map(({ k, label, type, ph }) => (
          <div key={k}>
            <label className="block text-sm font-semibold text-gray-600 mb-1">{label}</label>
            <input
              type={type} required value={form[k]} onChange={f(k)} placeholder={ph}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
            />
          </div>
        ))}

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Foto da CNH frente</label>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={e => handleImageCapture('cnhFrontImage', e.target.files?.[0])}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary bg-white"
          />
          {form.cnhFrontImage && (
            <img src={form.cnhFrontImage} alt="CNH frente" className="mt-3 w-full h-32 object-cover rounded-xl border border-gray-200" />
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Foto da CNH verso</label>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={e => handleImageCapture('cnhBackImage', e.target.files?.[0])}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary bg-white"
          />
          {form.cnhBackImage && (
            <img src={form.cnhBackImage} alt="CNH verso" className="mt-3 w-full h-32 object-cover rounded-xl border border-gray-200" />
          )}
        </div>

        {/* Brand selection */}
        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-2">
            Marcas que você trabalha <span className="text-red-500">*</span>
          </label>
          <div className="grid grid-cols-2 gap-2">
            {brands.map(b => (
              <button
                key={b.id}
                type="button"
                onClick={() => toggleBrand(b.id)}
                className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border-2 text-sm font-semibold transition-all ${form.brands.includes(b.id) ? 'border-primary bg-orange-50 text-primary' : 'border-gray-200 text-gray-600'}`}
              >
                <BrandIcon brandId={b.id} size={32} />
                <span className="text-xs">{b.name}</span>
                {form.brands.includes(b.id) && <span className="ml-auto text-primary">✓</span>}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 text-xs text-gray-700 leading-5">
          <div className="font-black text-amber-700 mb-2">Termo de responsabilidade</div>
          <p>
            A plataforma apenas capta a venda e repassa para entrega. Não há vínculo empregatício com o entregador, nem responsabilidade pelas condições do veículo. O entregador deve manter aparência apresentável, respeito ao cliente e conduta compatível com as leis brasileiras. Comportamentos inaceitáveis podem gerar exclusão da plataforma. Caso o cliente solicite instalação, a responsabilidade pelo ato executado é do entregador/prestador.
          </p>
        </div>

        <label className="flex items-start gap-3 bg-gray-50 rounded-2xl p-4">
          <input
            type="checkbox"
            checked={form.acceptedTerms}
            onChange={e => setForm(p => ({ ...p, acceptedTerms: e.target.checked }))}
            className="mt-1"
          />
          <span className="text-xs text-gray-600">
            Li e aceito o termo. Estou ciente de que meu cadastro pode levar até 24 horas para ser liberado.
          </span>
        </label>

        <button
          type="submit" disabled={loading}
          className="w-full py-4 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-2xl font-bold text-white text-lg transition-all active:scale-95"
        >
          {loading ? 'Cadastrando...' : 'Criar Conta'}
        </button>

        <p className="text-center text-xs text-amber-600 font-semibold">
          Após o envio, o cadastro ficará em análise por até 24 horas.
        </p>

        <p className="text-center text-sm text-gray-500">
          Já tem conta? <Link to="/entregador/login" className="text-primary font-bold">Entrar</Link>
        </p>
      </form>
    </div>
  );
}
